import React, { useState, useEffect } from "react";
import styles from "./mob_search_form.module.css";


function MobSearchForm({
  handleClose
}) {

  const [inputValue, setInputValue] = useState('');
  // const [isEmptyInput, setIsEmptyInput] = useState(false);

  const handleChangeInput = (e) => {
    setInputValue(e.target.value);
  }

  const handleCloseSearch = () => {
    localStorage.removeItem('keyWord');
    handleClose();
  }


  useEffect(() => {
    setInputValue(localStorage.getItem('keyWord'));
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    if (inputValue) {
      console.log('submit ', inputValue);
    }
    // handleSubmit({
    //   keyWord: inputValue
    // });

    // inputValue ? setIsEmptyInput(false) : setIsEmptyInput(true);
  }

  return (
      <form
        className={styles.form}
        onSubmit={onSubmit}
        noValidate
      >
        <button className={styles.buttonCloseSearch}
          type="button"
          onClick={handleCloseSearch}
        />
        <input
          id="search-input"
          name="search"
          className={`${styles.input}`}
          type="text"
          placeholder="Поиск"
          onChange={handleChangeInput}
          value={inputValue || ''}
        />
        <button type="submit" className={`${styles.buttonSubmit}`} />
      </form>
  );
}

export default MobSearchForm;
